import React from 'react';
import { useFormikContext } from 'formik';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import ReanalysisInProgressIndicator from 'ff/debrief/components/ReanalysisInProgressIndicator';
import { VspeedFormValues } from './VspeedFormValues';

interface Props {
    onClose: () => void;
}

const VspeedModalActions = (props: React.PropsWithChildren<Props>) => {
    const { isSubmitting, isValid } = useFormikContext<VspeedFormValues>();

    return (
        <DialogActions>
            <ReanalysisInProgressIndicator />
            <Button
                onClick={props.onClose}
                disabled={isSubmitting}
                variant="outlined"
                color="info"
                size="small"
            >
                Cancel
            </Button>
            <Button
                disabled={isSubmitting || !isValid}
                type="submit"
                variant="contained"
                color="primary"
                size="small"
            >
                Save
            </Button>
        </DialogActions>
    );
};

export default VspeedModalActions;
